var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.62,
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_497_361",
    transform: "scale(0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_497_361",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAAsQAAALEBxi1JjQAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAGFSURBVEiJ3dW/S9VRGAbwj5eSavEHFFG6CrmltNTUEDrUVOCkkw6B2RBR/RPZIlhbRZHQVFtTQ9KSk3D/AX9hUCJiRWK34T1xL7eLne/XO/XAgS/nfd7nOef7vryHfDzAelr3C+Rl4QZqeJdWDdfbaTCPb7iMK+l7vh3CnbiJNXHqxrWCKVTKip/FxyS2hLu4hquiBssp9h69RcV7UMUuJtDRglPBNH7iE04UMXiKPYxmcMfwC7O54gPYx1yBA70QNzmdQ74n/u1AAYOhlHMrh/wSGwXEiRp9wfPmQKsWO4nPBQ1qopVP5RhURA2KYg9Hcgzaiv/LoB8zOIevJbS2Uu4M+pqDF7AjumEVF0sYXEq5taQ13Bh8i00MlhBuxqBo8zfUf1G36ONqGwyq4ibd1Pv2NR7hg3gSD4MzOI/b1MdwBXcw7u8CHcNxbIup+Yffhe/40cRfxTM8bOAfiFFRuMmGvam0N5Ij8C8cxaIYx6+wIMbCohajoSx68URM2Q08lvlM/gaa5VbfFqEb4gAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bellIcon.8b61bedc45b15db1eccf51fb75070555.svg";
export { ForwardRef as ReactComponent };